import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const Svg4VCrown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M38.146 9.859 24.005 4.001 9.864 9.859 4.006 24l5.857 14.142 14.141 5.857 14.141-5.857L44.004 24zM40.135 22.5h-4.998l-2.2-5.312 3.534-3.534zM17.193 32.933l5.312 2.2v4.997l-8.845-3.664zm8.312 2.2 5.311-2.2 3.534 3.533-8.845 3.664zm4.515-5.118-6.015 2.491-6.016-2.491L15.498 24l2.491-6.015 6.016-2.492 6.015 2.492L32.512 24zm.797-14.948-5.312-2.2V7.871l8.845 3.664zm-8.312-2.2-5.312 2.2-3.533-3.533 8.845-3.664zm-10.966.788 3.534 3.534-2.2 5.312H7.875zM7.875 25.5h4.998l2.2 5.312-3.534 3.534zm28.596 8.845-3.534-3.534 2.2-5.312h4.998z" }) }) })
});
export default Svg4VCrown;
